import { useEffect, useState } from 'react';

import type { Site } from '../model';

const PLACEHOLDER = 'my site';

export const useSiteName = (site: Site | undefined): string => {
  const [siteName, setSiteName] = useState('');

  useEffect(() => {
    if (site) {
      setSiteName(site.name || site.url || PLACEHOLDER);
    }
  }, [site, setSiteName]);

  return siteName;
};
